// import { Container } from "../../styledComponents/Container/styled";
// import YoutubeEmbed from "../../features/Hooks/YoutubeEmbed";

// const Video = () => {
//   return (
//       <>
//  {/* <h1>Dragonscape jest Twoją drogą</h1> */}
//  <YoutubeEmbed embedId="xmtb0i0Ithc" />
//       </>
//   );
// };

// export default Video;

import VimeoEmbed from "../../features/Hooks/VimeoEmbed";

const Video = () => {
  return (
      <>
        <VimeoEmbed embedId="1093303262" />
      </>
  );
};

export default Video;